import React from 'react'
import { ScheduleDesviationTable } from 'components/table/schedule_desviation/ScheduleDesviationTable'

const ScheduleDeviation = () => {
    return (
        <>
            <ScheduleDesviationTable/>
        </>
    )
}

export { ScheduleDeviation }